import { useMutation } from '@tanstack/react-query';
import { POST, POST_UPDATE_USER_INFO } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';

export const useUpdateUserInfo = ({ onSuccessCallBack }) => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (payload) => {
      const response = await POST(POST_UPDATE_USER_INFO(), payload);
      onSuccessCallBack && onSuccessCallBack(response);
      return response.item;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'แก้ไขข้อมูลลูกค้าสำเร็จ',
      });
    },
  });
  return { mutate, loading: isPending };
};
